'use strict';

var _ = require('lodash');
var ProfileChartPanelController = function ProfileChartPanelController($scope, $q, constants, dataService) {
  $scope.contextData = _.assign($scope.contextData, {
    sidebar: {
      visible: true
    }
  });
  $scope.enableNextPreviousButtons = _.isEqual($scope.contextData.screenMode, constants.FLIGHT_MANAGEMENT_MODE);
  function getParams(contextData) {
    var params = _.pick(contextData, ['target', 'screen', 'mode', 'subMode', 'dimension', 'screenMode', 'selectedService', 'legendFilter', 'selectedReference']);
    params.selectedMetric = contextData.selectedMetric.id;
    return params;
  }
  $scope.reloadChart = function () {
    var params = getParams($scope.contextData);
    return dataService.getPrimaryEntityData(params).then(function (primaryEntity) {
      $scope.contextData = _.assign({}, $scope.contextData, {
        primaryEntity: primaryEntity
      });
      return dataService.getReferenceEntitiesData(params, $scope.contextData.referenceEntities);
    }).then(function (entities) {
      var referenceEntities = dataService.addReferenceEntities($scope.contextData.referenceEntities, entities);
      var chartData = dataService.generateChartData($scope.contextData.primaryEntity, referenceEntities);
      $scope.contextData = _.assign({}, $scope.contextData, {
        referenceEntities: referenceEntities,
        chartData: chartData
      });
    });
  };

  // rename it to addReferenceEntity
  $scope.getReferenceEntity = function (entity) {
    var params = _.assign(getParams($scope.contextData), {
      selectedService: entity
    });
    return dataService.getReferenceEntityData(params).then(function (entityData) {
      var referenceEntities = dataService.addReferenceEntity($scope.contextData.referenceEntities, entityData);
      var chartData = dataService.generateChartData($scope.contextData.primaryEntity, referenceEntities);
      $scope.contextData = _.assign({}, $scope.contextData, {
        referenceEntities: referenceEntities,
        chartData: chartData
      });
    });
  };
  $scope.removeReferenceEntity = function (entity) {
    var referenceEntities = dataService.removeReferenceEntity($scope.contextData.referenceEntities, entity);
    var chartData = dataService.generateChartData($scope.contextData.primaryEntity, referenceEntities);
    $scope.contextData = _.assign({}, $scope.contextData, {
      referenceEntities: referenceEntities,
      chartData: chartData
    });
  };
  $scope.$watch('contextData.selectedRowIndexes', function (newValue, oldValue) {
    if (!_.isEqual(newValue, oldValue)) {
      $scope.contextData.selectedService = _.get($scope.contextData.visibleRowProperties.displayRows, newValue);
      $scope.reloadChart();
    }
  });
  var buildChartTitle = _.template('<%=carrier%><%=flightNumber%> <%=leg%> <%=flightDepartureDate%>');
  function updateChartTitle(newEntity, oldEntity) {
    $scope.chartTitle = _.isEqual(newEntity, oldEntity) ? buildChartTitle(oldEntity) : buildChartTitle(newEntity);
  }
  $scope.$watch('contextData.primaryEntity', updateChartTitle);
  $scope.$watch('contextData.legendFilter', function (newValue, oldValue) {
    if (!_.isEqual(newValue, oldValue)) {
      $scope.reloadChart();
    }
  });
  $scope.toggleSideBar = function () {
    $scope.contextData.sidebar.visible = !$scope.contextData.sidebar.visible;
  };
  $scope.competitorFaresProfileEnabled = function () {
    return _.get($scope.contextData.selectedMetric, 'id') === 'competitorFaresProfile';
  };
};
ProfileChartPanelController.$inject = ['$scope', '$q', 'DataRetrieverConstantsService', 'ProfileChartPanelDataService'];
module.exports = ProfileChartPanelController;